<template>
    <header :class="[state.isScroll === false ? state.headerClass : '']">
        <div class="header_wrap">
            <button class="menu_btn D_none" @click="mobileMenu" :class="{ cross: state.mobileMenuOpen }">
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </button>
            <div class="logo_wrap">
                <h1>
                    <router-link to="/" class="icon_wrap">
                        <img
                            :class="state.menuOverFlag === true || state.isScroll === true ? 'black' : ''"
                            src="img/logo.png"
                            alt="반성매매 시민참여 플랫폼"
                        />
                    </router-link>
                </h1>
                <a href="http://dasi.or.kr/" class="icon_wrap center_btn D_only none_1240" target="_blank">
                    <img src="img/center.png" alt="다시함께상담센터" />
                </a>
            </div>

            <div class="nav_wrap" :class="{ active: state.mobileMenuOpen }">
                <Menu
                    @mouseover="state.menuOverFlag = true"
                    @mouseleave="state.menuOverFlag = false"
                    :customClass="state.headerClass !== undefined && state.menuOverFlag === false && state.isScroll === false"
                    :class="{ active: state.mobileMenuOpen }"
                ></Menu>
                <div class="utility_wrap D_only only_1240">
                    <!-- 로그인 전 -->
                    <template v-if="!state.isLogin">
                        <router-link to="/login">로그인</router-link>
                        <router-link to="/join">회원가입</router-link>
                    </template>
                    <!-- 로그인 전 -->
                    <!-- 로그인 후 -->
                    <template v-else>
                        <div :class="[state.isFloat ? 'area_login' : '']">
                            <!-- 로그인 후 -->
                            <div class="user_btn" @click="state.isFloat = !state.isFloat">
                                <img src="img/user_icon.png" alt="" />
                                <span>{{ user.userInfo.name }}님</span>
                            </div>

                            <div class="btn_wrap _default" v-if="state.isFloat">
                                <button
                                    @click="
                                        router.push('/mypage');
                                        state.isFloat = false;
                                    "
                                    class="common_btn"
                                >
                                    마이페이지
                                </button>
                                <button @click="logout" class="common_btn _gray">로그아웃</button>
                            </div>
                        </div>
                        <!-- 로그인 후 -->
                    </template>
                </div>
                <a href="" class="icon_wrap center_btn D_none only_1240">
                    <img src="img/center.png" alt="다시함께상담센터" />
                </a>
            </div>
            <div class="m_menu_bg D_none"></div>

            <div
                class="utility_wrap D_only none_1240"
                style="position: relative; justify-content: center"
                :class="state.menuOverFlag === true ? 'black' : ''"
            >
                <!-- :class="[state.headerClass !== undefined && state.menuOverFlag === false && state.isScroll === false ? '_white' : '']" -->
                <template v-if="!state.isLogin">
                    <router-link to="/login">로그인</router-link>
                    <router-link to="/join">회원가입</router-link>
                </template>
                <!-- 로그인 전 -->
                <!-- 로그인 후 -->
                <template v-else>
                    <div :class="[state.isFloat ? 'area_login' : '']">
                        <!-- 로그인 후 -->
                        <div class="user_btn" @click="state.isFloat = !state.isFloat">
                            <img src="img/user_icon.png" alt="" />
                            <span>{{ user.userInfo.name }}님</span>
                        </div>

                        <div class="btn_wrap _default" v-if="state.isFloat">
                            <button
                                @click="
                                    router.push('/mypage');
                                    state.isFloat = false;
                                "
                                class="common_btn"
                            >
                                마이페이지
                            </button>
                            <button @click="logout" class="common_btn _gray">로그아웃</button>
                        </div>
                    </div>
                    <!-- 로그인 후 -->
                </template>
            </div>
        </div>
    </header>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts">
    import Menu from "@/views/layout/menu.vue";
    import {
        apiService,
        onMounted,
        reactive,
        router,
        userStore,
        returnCode,
        globalStore,
        watch,
        types,
        useRoute,
        ref,
        onUnmounted,
        getMessageByCode,
        ModalDefault,
    } from "@/BaseComponent";

    export default {
        components: { Menu, ModalDefault },
        setup() {
            const user = userStore();
            const route = useRoute();
            const global = globalStore();
            const { changeCode } = returnCode();

            const userInfo = reactive({
                info: {} as any,
                password: "" as string,
                password_ck: "" as string,
                name: user.userInfo?.name as string,
                id: user.userInfo?.id as string,
            });
            const state = reactive({
                searchDate: [] as any,
                userMenu: false,
                settingMenu: false,
                isModalOpen: false,
                isUserModal: false,
                isKeywordModal: false,
                isHelperModal: false,
                position: [] as any,
                dept: [] as any,
                isLogin: false as boolean,
                isFloat: false as boolean,

                menuOverFlag: false as boolean,
                headerClass: [] as Array<string>,
                isScroll: false as boolean,

                mobileMenuOpen: false,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const modal = reactive({
                title: "",
                customClass: {
                    wrap: [] as Array<string>,
                    button: [] as Array<string>,
                },
                list: [] as any,
                fields: [] as any,
                cancel: "",
                confirm: "",
                type: "nation",
                actionCode: 0 as number,
                isBtn: true as boolean,
            });

            const scrollY = ref(0);

            onMounted(async () => {
                checkLogin();
                window.addEventListener("scroll", handleScroll);

                state.headerClass = route.meta.headerClass as string[];

                router.afterEach(() => {
                    if (state.mobileMenuOpen) {
                        mobileMenu();
                    }
                });

                if (state.isLogin) me();
            });

            onUnmounted(() => {
                window.removeEventListener("scroll", handleScroll);
            });

            watch(
                () => user.accessToken,
                () => {
                    checkLogin();
                },
            );

            watch(
                () => route.fullPath,
                () => {
                    if (state.mobileMenuOpen) {
                        mobileMenu();
                    }
                },
            );

            const handleScroll = () => {
                scrollY.value = window.scrollY;

                if (scrollY.value >= 60) {
                    state.isScroll = true;
                } else {
                    state.isScroll = false;
                }
            };

            const checkLogin = () => {
                if (user.isLogin()) {
                    state.isLogin = true;
                } else {
                    state.isLogin = false;
                }
            };

            const handleOutsideClick = () => {
                state.userMenu = false;
            };

            const handleOutsideClick2 = () => {
                state.settingMenu = false;
            };

            const me = async () => {
                let res: types.ResUserInfo = await apiService.mypage.me();
                if (res.returnCode === 0) {
                    user.setInfo({
                        id: res.data.memberVO.id,
                        idx: res.data.memberVO.idx,
                        name: res.data.memberVO.name,
                        isAdmin: res.data.memberVO.gubun !== 3,
                        gubun: res.data.memberVO.gubun,
                        snsGubun: res.data.gubun !== 1,
                        hasAuth: res.data.memberVO.hasAuth,
                    });
                    user.setRole(res.data.roleVO);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const logout = async () => {
                if (user && user.accessToken != null && user.accessToken != "") {
                    let res: types.BaseResponse = await apiService.auth.logout();

                    if (res !== null && res.returnCode === 0) {
                        state.isLogin = false;
                        user.$reset();
                        router.replace("/");
                    } else {
                        state.isLogin = true;
                    }
                }
            };

            const openMenu = (menuIdx: number) => {
                switch (menuIdx) {
                    case 0:
                        state.userMenu = !state.userMenu;
                        state.settingMenu = false;
                        break;
                    case 1:
                        state.settingMenu = !state.settingMenu;
                        state.userMenu = false;
                        break;
                }
            };

            const mobileMenu = () => {
                if (window.innerWidth <= 1024) {
                    state.mobileMenuOpen = !state.mobileMenuOpen;
                    const body = document.querySelector("body");
                    if (body) {
                        if (state.mobileMenuOpen) {
                            body.style.overflow = "hidden";
                        } else {
                            body.style.overflow = "";
                        }
                    }
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const callBackModal = async (param: any) => {};

            return {
                state,
                userInfo,
                modal,
                openMenu,
                mobileMenu,
                logout,

                router,

                handleOutsideClick,
                handleOutsideClick2,
                user,
                closeModal,
                callBackModal,
            };
        },
    };
</script>
<style scoped>
    header._transparent {
        background-color: transparent;
    }

    header._transparent > div.header_wrap {
        background-color: transparent;
    }
    header._transparent > div.header_wrap:before {
        height: 0;
    }
    header._transparent .bar {
        background-color: #fff;
    }
    header._transparent .cross .bar {
        background-color: #000;
    }
    .utility_wrap.black :where(button, a) {
        color: #000;
    }
    .user_btn {
        cursor: pointer;
    }
    /* header.sub_mypage {
        --bg_url: url(~@/assets/mypage_bg.png);
    }

    header.sub_intro {
        --bg_url: url(~@/assets/intro_bg.png);
    }

    header.sub_report {
        --bg_url: url(~@/assets/report_bg.png);
    }

    header.sub_board {
        --bg_url: url(~@/assets/activity_bg.png);
    }

    header.sub_news {
        --bg_url: url(~@/assets/news_bg.png);
    }

    ._white a {
        color: white;
    } */
</style>
